import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "grid grid-cols-1 place-items-center mt-52 m-4"
}
const _hoisted_3 = { class: "bg-white p-4 text-center rounded" }
const _hoisted_4 = { class: "my-4" }
const _hoisted_5 = { class: "text-left" }
const _hoisted_6 = { class: "my-4" }
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = { class: "my-4" }
const _hoisted_9 = { class: "text-left" }
const _hoisted_10 = { class: "my-4" }
const _hoisted_11 = { class: "text-left" }
const _hoisted_12 = { class: "my-4" }
const _hoisted_13 = { class: "text-left" }
const _hoisted_14 = { class: "flex flex-wrap flex-row gap-3 items-center mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Enable notifications", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Enable notifications", -1)
const _hoisted_17 = { class: "my-auto font-medium text-base" }
const _hoisted_18 = { class: "relative w-full" }
const _hoisted_19 = { class: "absolute -top-10 -right-4" }
const _hoisted_20 = { class: "text-center text-xl font-semibold uppercase m-0" }

import { AxiosInstance } from "axios";
import { inject, onMounted, ref } from "vue";
import { Switch } from "@headlessui/vue";
import { LoyaltyConfig } from "./types/config.type";
import { XCircleIcon } from "@heroicons/vue/solid";
import Navbar from "@/components/tools/Navbar.vue";
import DialogComponent from "@/components/doalog/DialogComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Config',
  setup(__props) {

const axios = inject("$axios") as AxiosInstance;
const configData = ref<LoyaltyConfig>(undefined);
const updateDialog = ref({
  open: false,
  message: "",
});

const onSubmit = async () => {
  if (
    configData.value.cashPointRate &&
    configData.value.cashPointRate >= 0 &&
    configData.value.maxRedeemPoint &&
    configData.value.maxRedeemPoint >= 0 &&
    configData.value.pointRate &&
    configData.value.pointRate >= 0
  ) {
    const update = await axios
      .put(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/loyalty/api/internal/config/update`,
        configData.value
      )
      .then((data) => data.data);
    if (update) {
      updateDialog.value = {
        open: true,
        message: "update success",
      };
    } else {
      updateDialog.value = {
        open: true,
        message: "update fail",
      };
    }
  } else {
    updateDialog.value = {
      open: true,
      message:
        "Cash Point Rate, Max RedeemPoint and Point Rate are require and its must greater than 0",
    };
  }
};
onMounted(async () => {
  configData.value = await axios
    .post(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/loyalty/api/internal/config/detail`
    )
    .then((data) => data.data);
  if (!configData.value.isActive) configData.value.isActive = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Navbar, {
        title: _ctx.$t('messages.loyaltyConfig.loyaltyConfig')
      }, null, 8, ["title"]),
      (configData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("messages.loyaltyConfig.rate")) + " ( " + _toDisplayString(_ctx.$t("messages.loyaltyConfig.bet")) + ": " + _toDisplayString(_ctx.$t("messages.loyaltyConfig.amountPerPoint")) + ") ", 1),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "rounded w-full",
                  min: "1",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((configData.value.pointRate) = $event))
                }, null, 512), [
                  [_vModelText, configData.value.pointRate]
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("messages.loyaltyConfig.cashPerPoint")), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "rounded w-full",
                  min: "1",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((configData.value.cashPointRate) = $event))
                }, null, 512), [
                  [_vModelText, configData.value.cashPointRate]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("messages.loyaltyConfig.maxRedeemPoint")), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "rounded w-full",
                  min: "1",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((configData.value.maxRedeemPoint) = $event))
                }, null, 512), [
                  [_vModelText, configData.value.maxRedeemPoint]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("messages.loyaltyConfig.expiry")) + " ( " + _toDisplayString(_ctx.$t("messages.loyaltyConfig.month")) + ") ", 1),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "rounded w-full",
                  min: "1",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((configData.value.pointMonthExpired) = $event))
                }, null, 512), [
                  [_vModelText, configData.value.pointMonthExpired]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("messages.loyaltyConfig.redeemFortuneWheelLimit")), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "rounded w-full",
                  min: "1",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((configData.value.redeemFortuneWheelLimit) = $event))
                }, null, 512), [
                  [_vModelText, configData.value.redeemFortuneWheelLimit]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("messages.loyaltyConfig.activated")), 1),
                _createVNode(_unref(Switch), {
                  modelValue: configData.value.isActive,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((configData.value.isActive) = $event)),
                  class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", configData.value.isActive ? 'bg-blue-400' : 'bg-red-500'])
                }, {
                  default: _withCtx(() => [
                    _hoisted_15,
                    _createElementVNode("span", {
                      class: _normalizeClass([configData.value.isActive ? 'translate-x-6' : 'translate-x-1', "inline-block h-4 w-4 transform rounded-full bg-white"])
                    }, null, 2)
                  ]),
                  _: 1
                }, 8, ["modelValue", "class"]),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("messages.loyaltyConfig.cashrewardEnable")), 1),
                _createVNode(_unref(Switch), {
                  modelValue: configData.value.cashRewardEnable,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((configData.value.cashRewardEnable) = $event)),
                  class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", configData.value.cashRewardEnable ? 'bg-blue-400' : 'bg-red-500'])
                }, {
                  default: _withCtx(() => [
                    _hoisted_16,
                    _createElementVNode("span", {
                      class: _normalizeClass([
                configData.value.cashRewardEnable ? 'translate-x-6' : 'translate-x-1'
              , "inline-block h-4 w-4 transform rounded-full bg-white"])
                    }, null, 2)
                  ]),
                  _: 1
                }, 8, ["modelValue", "class"])
              ]),
              _createElementVNode("button", {
                class: "bg-blue-400 px-7 py-2 text-white rounded",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (onSubmit()))
              }, [
                _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("messages.loyaltyConfig.save")), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(DialogComponent, {
      isOpen: updateDialog.value.open
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_unref(XCircleIcon), {
              class: "ml-auto w-8 h-8 cursor-pointer",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (updateDialog.value.open = false))
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_20, _toDisplayString(updateDialog.value.message), 1)
      ]),
      _: 1
    }, 8, ["isOpen"])
  ], 64))
}
}

})